import {
    Box,
    Button,
    Flex,
    Grid,
    Input,
    rem,
    Select,
    TextInput
} from "@mantine/core";
import {
    IconBrandBootstrap,
    IconSearch,
    IconTimeDuration15
} from "@tabler/icons-react";
import {
    MantineReactTable,
    MRT_ColumnDef,
    MRT_PaginationState,
    MRT_RowSelectionState,
    useMantineReactTable,
} from "mantine-react-table";
import React, { startTransition, useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconFileExport } from "@tabler/icons-react";
import moment from "moment";
import {
    repositoryMdm,
    repositoryPos,
    styleTableMantine
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { formatPrice } from "../../../../common/formatPrice/PriceFunction";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../../config";
import { _localization } from "../../../../config/location";
import { MessageResponse } from "../../../../model/MessageResponse";
import { SelectListItem } from "../../../../model/SelectListItem";
import { DiscountReportItem } from "../../../../model/DiscountReportItem";

interface SearchCriteria {
    MaDonBan?: string | number;      // Mã đơn bán / Số đơn
    NguoiDuyet?: string | number;    // Người duyệt (id hoặc mã)
    FromDate?: Date | string;        // Ngày bắt đầu (Date hoặc ISO/string)
    ToDate?: Date | string;          // Ngày kết thúc (Date hoặc ISO/string)
    MaKhachHang?: string;            // Mã khách hàng
    MaHangHoa?: string;              // Mã hàng hóa / sản phẩm
    BranchName?: string;             // Tên hoặc mã chi nhánh
    KeySearch?: string;
    ctu?: string;
}

const BaoCaoGiamGia = () => {
    // Khởi tạo component InventoryReportList
    const headerRef = React.useRef<HTMLDivElement>(null);
    const [isRefetching, setIsRefetching] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: 0,
        pageSize: 20,
    });
    const [visible, { toggle, close, open }] = useDisclosure(false);
    const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

    const [height, setHeight] = useState(0);
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
    const [data, setData] = useState<DiscountReportItem[]>([]);
    const [rowCount, setRowCount] = useState(0);
    const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);

    const form = useForm<SearchCriteria>({
        mode: "uncontrolled",
        initialValues: {},
    });

    const columns = React.useMemo<MRT_ColumnDef<DiscountReportItem>[]>(
        () => [
            {
                accessorKey: "STT", header: "STT",
                Cell: ({ renderedCellValue, row }) => (
                    <>{row.index + 1}</>
                ),
                size: 90,
            },
            { accessorKey: "maKh", header: "Mã KH" },
            { accessorKey: "chiNhanh", header: "Chi nhánh" },
            {
                accessorKey: "ngayCt", header: "Ngày chứng từ",
                Cell: ({ renderedCellValue, row }) => (
                    <>{renderedCellValue}</>
                ),
            },
            {
                accessorKey: "ngayDuyet", header: "Ngày duyệt",
                Cell: ({ renderedCellValue, row }) => (
                    <>{renderedCellValue}</>
                ),
            },
            { accessorKey: "soDonBan", header: "Mã đơn hàng" },
            {
                accessorKey: "maHang",
                header: "Mã hàng",
                Cell: ({ renderedCellValue, row }) => (
                    <>{renderedCellValue}</>
                ),
            },
            {
                accessorKey: "soLuong",
                header: "Số lượng",
                Cell: ({ renderedCellValue, row }) => (
                    <>{renderedCellValue}</>
                ),
            },
            { accessorKey: "ctu", header: "Loại đơn hàng" },
            {
                accessorKey: "dt", header: "Doanh thu"
                ,
                Cell: ({ renderedCellValue, row }) => (
                    <>{formatPrice(Number(renderedCellValue))}</>
                ),
            },

            {
                accessorKey: "lng", header: "LNG",
                Cell: ({ renderedCellValue, row }) => (
                    <>{formatPrice(Number(renderedCellValue))}</>
                ),
            },
            { accessorKey: "lngDt", header: "LNG/DT" },
            // {
            //     accessorKey: "tTienTheoSp", header: "Tiền theo SP",
            //     Cell: ({ renderedCellValue, row }) => (
            //         <>{formatPrice(Number(renderedCellValue))}</>
            //     ),
            // },
            {
                accessorKey: "tienVon", header: "Tiền vốn",
                Cell: ({ renderedCellValue, row }) => (
                    <>{formatPrice(Number(renderedCellValue))}</>
                ),
            },
            {
                accessorKey: "mucGiamGiaTheoKh", header: "Mức giảm giá theo KH",
                Cell: ({ renderedCellValue, row }) => (
                    <>{renderedCellValue}</>
                ),
                size: 250,
            },
            {
                accessorKey: "mucGiamToiDa", header: "Mức được giảm tối đa",
                Cell: ({ renderedCellValue, row }) => (
                    <>{formatPrice(Number(renderedCellValue))}</>
                ),
            },
            {
                accessorKey: "mucQlyDuyet",
                header: form.getValues().ctu === "Ban buon" ? "Giá bán thực tế" : "Mức QL duyệt",
                Cell: ({ renderedCellValue, row }) => (
                    <>{formatPrice(Number(renderedCellValue))}</>
                ),
            },
            {
                accessorKey: "chenhLech", header: "CL so với mức giảm tối đa",
                Cell: ({ renderedCellValue, row }) => (
                    <>{formatPrice(Number(renderedCellValue))}</>
                ),
            },
            { accessorKey: "qlyDuyet", header: "Người duyệt" },
            { accessorKey: "lyDo", header: "Lý do" },
        ],
        [data]
    );

    // Hàm lấy dữ liệu
    const fetchData = async () => {
        setIsLoading(true);
        setIsRefetching(true);
        setIsError(false);

        // let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${pagination.pageSize
        //     }`;
        const search = form.getValues();
        let queryParams = {
            MaDonBan: search.MaDonBan,
            NguoiDuyet: search.NguoiDuyet,
            FromDate: search.FromDate
                ? moment(search?.FromDate).format("YYYY-MM-DDT00:00:00.000[Z]")
                : "",
            ToDate: search.ToDate
                ? moment(search?.ToDate).format("YYYY-MM-DDT23:59:59.999[Z]")
                : undefined,
            MaKhachHang: search.MaKhachHang,
            MaHangHoa: search.MaHangHoa,
            BranchName: search.BranchName,
            KeySearch: search.KeySearch,
            ctu: search.ctu,
        }
        let url =
            `/api/v1/VBaoCaoGiamGia/get-list?` +
            Object.entries({
                ...queryParams,
                Skip: pagination.pageIndex * pagination.pageSize,
                Take: pagination.pageSize,
            })
                .filter(([, value]) => value !== undefined && value !== "" && value !== null)
                .map(
                    ([key, value]) =>
                        `${key}=${encodeURIComponent(
                            value as string | number | boolean
                        )}`
                )
                .join("&");
        try {
            const response = await repositoryMdm.get(url);
            if (response && response.success) {
                let result = response.data.items as DiscountReportItem[];
                setData(result);
                setRowCount(response.data.totalCount);
                table.resetRowSelection();
            } else {
                setData([]);
                setRowCount(response.data.totalCount);
            }
        } catch (error) {
            setData([]);
            setIsError(true);
            console.error(error);
            return;
        } finally {
            setIsLoading(false);
            setIsRefetching(false);
        }
    };

    const table = useMantineReactTable({
        columns,
        data,
        enableColumnResizing: true,
        rowCount,
        enableColumnFilters: true,
        enableSorting: true,
        enableColumnActions: true,
        // manualPagination: true,
        enableStickyFooter: true,
        state: {
            // columnFilters,
            // globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            showSkeletons: isLoading,
            rowSelection,
        },
        manualFiltering: false,
        manualPagination: true,
        manualSorting: false,
        onPaginationChange: setPagination,
        positionToolbarAlertBanner: "bottom",
        initialState: {
            showColumnFilters: false,
            columnPinning: {
                left: ["STT",],

            },
            columnVisibility: { id: false },
            density: "xs",
        },
        enableTopToolbar: false,
        mantineTopToolbarProps: {
            style: {
                borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
                marginBottom: 5,
            },
        },
        localization: _localization,
        // getRowId: (row) => row.departmentId,
        mantineTableContainerProps: {
            style: { maxHeight: height, minHeight: height },
        },
        enableStickyHeader: true,
        onRowSelectionChange: setRowSelection,
        mantineTableBodyCellProps: ({ row }) => ({
            style: styleTableMantine,
        }),
        mantineToolbarAlertBannerProps: false
            ? { color: "red", children: "Lỗi tải dữ liệu !" }
            : undefined,

        mantinePaginationProps: {
            showRowsPerPage: true,
            withEdges: true,
            radius: "xl",
            size: "lg",
            rowsPerPageOptions: ["20", "50", "100"],
        },
        paginationDisplayMode: "pages",
        enableColumnPinning: true,
        mantineTableProps: {
            striped: false,
        },
        mantineTableBodyRowProps: ({ row }) => ({
            onClick: row.getToggleSelectedHandler(),
            sx: { cursor: "pointer" },
        }),
    });



    // Hàm gọi API chi nhánh
    const fetchDataBranch = async () => {
        const dataApi = await repositoryPos.get<MessageResponse<any>>(
            "/api/v1/TblDmInventory/get-select-branch"
        );

        if (dataApi && dataApi.success) {
            const filteredData = dataApi.data.slice(1);
            setDataBranch(filteredData);
        }
    };


    const exportDataExcel = async () => {
        open(); // Hiển thị loading

        // Xây dựng URL API cuối cùng
        const token = localStorage.getItem("token");

        try {
            const search = form.getValues();
            let queryParams = {
                MaDonBan: search.MaDonBan,
                NguoiDuyet: search.NguoiDuyet,
                FromDate: search.FromDate
                    ? moment(search?.FromDate).format("YYYY-MM-DDT00:00:00.000[Z]")
                    : "",
                ToDate: search.ToDate
                    ? moment(search?.ToDate).format("YYYY-MM-DDT23:59:59.999[Z]")
                    : undefined,
                MaKhachHang: search.MaKhachHang,
                MaHangHoa: search.MaHangHoa,
                BranchName: search.BranchName,
                KeySearch: search.KeySearch,
                ctu: search.ctu,
            }
            let fullUrl =
                `${BASE_API_MDM}/api/v1/ExportExcel/export-bao-cao-giam-gia?` +
                Object.entries({
                    ...queryParams,
                    Skip: pagination.pageIndex * pagination.pageSize,
                    Take: pagination.pageSize,
                })
                    .filter(([, value]) => value !== undefined && value !== "" && value !== null)
                    .map(
                        ([key, value]) =>
                            `${key}=${encodeURIComponent(
                                value as string | number | boolean
                            )}`
                    )
                    .join("&");
            const response = await fetch(fullUrl, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token?.replace(/"/g, "")}`,
                    "Content-Type": "application/vnd.ms-excel",
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch the resource");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const filename = "bao_cao_doanh_so_ban_hang.xlsx"; // Tên mặc định nếu không có header
            const link = document.createElement("a");
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            close(); // Đóng loading
        }
    };
    useEffect(() => {
        startTransition(() => {
            fetchDataBranch();
        });
    }, []);
    useEffect(() => {
        const headerHeight = headerRef.current?.offsetHeight || 0;
        const handleResize = () => {
            setHeight(window.innerHeight - (165 + headerHeight));
        };

        handleResize(); // Set initial height
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [height]);
    useEffect(() => {
        fetchData();
    }, [pagination]);

    return (
        <Box>
            <LoadingOverlayCustom visible={visible} />
            <div ref={headerRef} style={{ width: "100%", marginBottom: "10px" }}>
                <Flex justify={"space-between"} w={"100%"}>
                    <_breadcrumb></_breadcrumb>
                    <Button
                        leftSection={
                            <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                        }
                        onClick={() => exportDataExcel()}
                    >
                        Export Excel
                    </Button>
                </Flex>
                <Grid>
                    <Grid.Col span={sizeGrid}>
                        <Input
                            placeholder="Nhập tìm kiếm"
                            key={form.key("keySearch")}
                            type="text"
                            leftSection={<IconSearch size={"20"} color="#15aabf" />}
                            onKeyDown={async (e) => {
                                if (e.key === "Enter") {
                                    await fetchData();
                                }
                            }}
                            {...form.getInputProps("keySearch")}
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <TextInput
                            key={form.key("MaDonBan")}
                            placeholder="Mã đơn hàng"
                            leftSection={<IconSearch color="#15aabf" />}
                            {...form.getInputProps("MaDonBan")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    fetchData();
                                }
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <Select
                            key={form.key("ctu")}
                            searchable
                            clearable
                            placeholder="loại đơn hàng"
                            comboboxProps={{
                                transitionProps: { transition: "pop", duration: 200 },
                            }}
                            leftSection={<IconBrandBootstrap color="#15aabf" />}
                            data={[
                                { label: 'Bản lẻ', value: 'Ban le' },
                                { label: 'Bán buôn', value: 'Ban buon' },
                            ]}
                            {...form.getInputProps("ctu")}
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <TextInput
                            key={form.key("MaKhachHang")}
                            placeholder="Mã khách hàng"
                            leftSection={<IconSearch color="#15aabf" />}
                            {...form.getInputProps("MaKhachHang")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    fetchData();
                                }
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <TextInput
                            key={form.key("NguoiDuyet")}
                            placeholder="Người duyệt"
                            leftSection={<IconSearch color="#15aabf" />}
                            {...form.getInputProps("NguoiDuyet")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    fetchData();
                                }
                            }}
                        />
                    </Grid.Col> <Grid.Col span={sizeGrid}>
                        <TextInput
                            key={form.key("MaHangHoa")}
                            placeholder="Mã hàng hóa"
                            leftSection={<IconSearch color="#15aabf" />}
                            {...form.getInputProps("MaHangHoa")}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    fetchData();
                                }
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <Select
                            key={dataBranch.length || form.key("BranchName")}
                            searchable
                            clearable
                            placeholder="Chi nhánh"
                            comboboxProps={{
                                transitionProps: { transition: "pop", duration: 200 },
                            }}
                            leftSection={<IconBrandBootstrap color="#15aabf" />}
                            data={dataBranch.map((item) => {
                                return {
                                    label: `${item.att2}-${item.text}`,
                                    value: String(item.att2),
                                };
                            })}
                            {...form.getInputProps("BranchName")}
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <DatePickerInput
                            type="default"
                            key={form.key("FromDate")}
                            leftSection={<IconTimeDuration15 color="#15aabf" />}
                            size="sm"
                            placeholder="Từ ngày"
                            locale="vi"
                            valueFormat="DD/MM/YYYY"
                            {...form.getInputProps("FromDate")}
                            clearable
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <DatePickerInput
                            key={form.key("ToDate")}
                            leftSection={<IconTimeDuration15 color="#15aabf" />}
                            size="sm"
                            placeholder="Đến ngày"
                            locale="vi"
                            valueFormat="DD/MM/YYYY"
                            {...form.getInputProps("ToDate")}
                            clearable
                        />
                    </Grid.Col>
                    <Grid.Col span={sizeGrid}>
                        <Button
                            color="blue"
                            variant="outline"
                            onClick={async () => {
                                await fetchData();
                            }}
                        >
                            Tìm kiếm
                        </Button>
                    </Grid.Col>
                </Grid>
            </div>
            <MantineReactTable table={table} />
        </Box>
    );
};

export default BaoCaoGiamGia;

